export enum TOAST_AFTER_EVENT {
  NONE,
  HISTORY_PUSH,
  HISTORY_BACK,
  HISTORY_REPLACE,
  LOCATION_HREF,
  LOCATION_HREF_REFERRER,
}

export enum TOAST_TEXT {
  NONE,
  ARTICLE_POSTED = '게시글이 등록되었습니다.',
  ARTICLE_DELETED = '게시글이 삭제되었습니다.',
  ARTICLE_MODIFIED = '게시글이 수정되었습니다.',
  REGISTER_MODIFIED = '우리집 정보가 수정되었습니다.',
  REGISTER_MODIFIED_UNAUTHENTICATED_ADDRESS = '주소지가 변경되어\n인증이 해지되었습니다.',
  REGISTER_MODIFIED_UNAUTHENTICATED_TRADE_TYPE = '주거형태가 변경되어\n집주인 인증이 해지되었습니다.',
  AGREE_TERMS_OF_SERVICE = '약관에 동의해 주세요.',
  AUTH_OWNER_COMPLETE = '집주인 인증이 완료되었습니다.',
  AUTH_RESIDENT_COMPLETE = '입주민 인증이 완료되었습니다.',
}
